import { render, staticRenderFns } from "./1035.vue?vue&type=template&id=fb70fbc6&scoped=true&"
import script from "./1035.vue?vue&type=script&lang=js&"
export * from "./1035.vue?vue&type=script&lang=js&"
import style0 from "./1035.vue?vue&type=style&index=0&id=fb70fbc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb70fbc6",
  null
  
)

export default component.exports